export enum AuthFlowType {
    Registration = "registration",
    PasswordReset = "password-reset",
}

export enum PasswordResetStep {
    Email = "email",
    Otp = "otp",
    NewPassword = "new-password",
    Success = "success",
}

export const OTP_LENGTH = 6;
